import { ReactNode } from "react";

interface SectionHeaderProps {
  subtitle?: string;
  title: ReactNode;
  description?: string;
  align?: "left" | "center";
  className?: string;
}

export default function SectionHeader({
  subtitle,
  title,
  description,
  align = "center",
  className = "",
}: SectionHeaderProps) {
  return (
    <div
      className={`${
        align === "center" ? "text-center" : "text-left"
      } ${className}`}
    >
      {subtitle && (
        <p className="section-subtitle mb-3">{subtitle}</p>
      )}
      <h2 className="section-title text-white">{title}</h2>
      {description && (
        <p className="text-muted-foreground/95 mt-5 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
